import { render } from "./NewWordOverview.vue?vue&type=template&id=59f48cc9&scoped=true"
import script from "./NewWordOverview.vue?vue&type=script&lang=js"
export * from "./NewWordOverview.vue?vue&type=script&lang=js"

import "./NewWordOverview.vue?vue&type=style&index=0&id=59f48cc9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f48cc9"]])

export default __exports__